<script>
export default {
  functional: true,
  name: "TContentBox",

  render(h, context) {
    const listEntries = context.props.items;
    return h("section", { class: "result-content" }, [
      h("h4", context.props.header),
      h(
        "ul",
        { class: "result-content-items" },
        listEntries.map((res, idx) => {
          return [h("li", res), idx < listEntries.length - 1 ? ", " : ""];
        })
      ),
    ]);
  },
};
</script>
